import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	RETFilesUploadRequest
} from '../requests/RETFilesUploadRequests.js';

import {
	GetRETFilesHistory
} from '../requests/RetAuditRequests.js';

export const RET_ENABLING_CHECKS = 'RET_ENABLING_CHECKS';

export const UploadRETFiles = (filePath, userName, userId) => async (dispatch) => {
	await RETFilesUploadRequest(filePath, userName, userId).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunFileUpload = (file, userName, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(UploadRETFiles(response.data, userName, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
